
import Vue from 'vue'
import InfoTooltip from '../info-tooltip/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'InfoTooltipList',
  components: {
    InfoTooltip
  },
  mixins: [staticBlockMixin]
})
